const features = {
  enableRegister: true,
  enableBnbPayment: true,
  enableReferral: true,
  enableUserSelectConfigForLangRedirect: false,
  enablePreferenceLanguage: true,
  enableDepositWithdraw: false,
  isCheckSourceOfFund: false,
  securityTipSupport: 'Binance',
  mainDomain: 'www.binance.com',
  enableTradeLevel: true,
  enableVolumnWithK: false,
  fiatSymbol: 'USD',
  isMultiFiatSymbol: false,
  fiatDepositWithdraw: false,
  defaultSelectedPair: 'BTC_USDT',
  defaultSelectedAssetTab: 'BTC',
  defaultSelectedStableCoinTabs: {
    'USDⓈ': 'USDⓈ',
    'ALTS': 'ALTS',
  },
  orderFormTotalPrecision: 8,
  componentConfig: {
    omitTradeMarketActivity: false,
    omitMiniSymbolListTabs: false,
    omitFavoriteStars: false,
    omitTradeFees: false,
    omit2FAWithdrawDeposit: false,
  },
  payments: {
    xfers: false,
    yoPayment: false,
    multiplePayment: false,
    omit2FA: false,
  },
  withdrawConfig: {},
  zendeskChatLanguage: ['cn', 'en'],
  creditCardConfig: {
    simplex: {
      cryptoCoinList: ['BTC', 'ETH', 'LTC', 'XRP'],
      fiatCoinList: ['USD', 'EUR'],
    },
  },
};

export default features;
